import React, { useState, useEffect } from "react";
import axios from "../../../library/axios";
import { Base64ViewerComp } from "../../";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const ScoreLipaComp = (props) => {
  const baseUrl = new URL(window.location.href);
  const [namaLengkap, setnamaLengkap] = useState("");
  const [group, setgroup] = useState("");
  const [lgShowIframe, setLgShowIframe] = useState(false);
  const [isPdf, setisPdf] = useState("application/pdf");
  const [link, setLink] = useState("");

  const fetchOneUser = async () => {
    // console.log(id)
    // return false
    try {
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data.data.mapping_groups[0]?.group?.namaGroup)
      setnamaLengkap(data.data.namaLengkap);
      setgroup(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchOneUser();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const downloadFile = (url, fileName) => {
    const concatUrl = baseUrl.origin.concat(`/${url}`);
    const link = document.createElement("a");
    link.href = concatUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const handleShowDocument = async (id) => {
    try {
      setLink("");
      const options = {
        url: `/skor/show-dokumen/${id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      if (data.data.mimeType !== isPdf) {
        downloadFile(data.data.link, data.data.namaFile);
        return false;
      }

      const concatUrl = baseUrl.origin.concat(`/${data.data.link}`);
      setLgShowIframe(true);
      setLink(concatUrl);
    } catch (err) {
      setLgShowIframe(false);
      console.log(err.message);
    }
  };

  // console.log(group)

  return (
    <>
      {lgShowIframe === true ? (
        <Base64ViewerComp link={link} close={() => setLgShowIframe(false)} />
      ) : (
        ""
      )}

      {props?.isSkorExist === true ? (
        <>
          <div className="col-lg-5 col-12">
            <div className="card card-bordered mb-1">
              <div className="card-header ribbon ribbon-top">
                <div className="ribbon-label bg-danger">
                  EP ({props?.element?.Abjad})
                </div>
                <div className="card-title">Elemen Penilaian</div>
              </div>
              <div className="card-body bg-danger">
                <h6 className="text-white">{props?.element?.Deskripsi}</h6>
                {props?.element?.IsDuring === 1 ? (
                  <>
                    <span className="badge badge-light-dark">Daring</span>&nbsp;
                  </>
                ) : (
                  ""
                )}

                {props?.element?.IsLuring === 1 ? (
                  <span className="badge badge-light-dark">Luring</span>
                ) : (
                  ""
                )}
              </div>
            </div>
            {/*begin::Accordion*/}
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-4 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Dokumen
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                    <div className="py-5">
                      <table className="table table-row-dashed table-row-gray-300 gy-7">
                        <thead className="bg-primary text-white">
                          <tr className="fw-bolder fs-6">
                            <th className="text-center">Aksi</th>
                            <th className="text-center">Nama File</th>
                          </tr>
                        </thead>
                        <tbody>
                          {props?.score?.documents?.map((document) => (
                            <tr key={document.id}>
                              <td className="text-center">
                                <button
                                  onClick={() =>
                                    handleShowDocument(document.id)
                                  }
                                  className="btn btn-primary btn-sm"
                                  type="button"
                                >
                                  Download
                                </button>
                              </td>
                              <td>{document.namaFile}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-4 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Skor
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                    <div className="py-5">
                      <table className="table table-row-dashed table-row-gray-300 gy-7">
                        <thead className="bg-primary text-white">
                          <tr className="fw-bolder fs-6">
                            <th className="text-center">Skor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              Skor :{" "}
                              {props?.score?.skorSurveyor !== ""
                                ? props?.score?.skorSurveyor
                                : props?.score?.Skor}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*end::Accordion*/}
          </div>
        </>
      ) : (
        <>
          <div className="col-lg-5 col-12">
            <div className="card card-bordered mb-1">
              <div className="card-header ribbon ribbon-top">
                <div className="ribbon-label bg-danger">
                  EP ({props?.element?.Abjad})
                </div>
                <div className="card-title">Elemen Penilaian</div>
              </div>
              <div className="card-body bg-danger">
                <h6 className="text-white">{props?.element?.Deskripsi}</h6>
                {props?.element?.IsDuring === 1 ? (
                  <>
                    <span className="badge badge-light-dark">Daring</span>&nbsp;
                  </>
                ) : (
                  ""
                )}

                {props?.element?.IsLuring === 1 ? (
                  <span className="badge badge-light-dark">Luring</span>
                ) : (
                  ""
                )}
              </div>
            </div>
            {/*begin::Accordion*/}
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-4 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Dokumen
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                    <div className="py-5">
                      <table className="table table-row-dashed table-row-gray-300 gy-7">
                        <thead className="bg-primary text-white">
                          <tr className="fw-bolder fs-6">
                            <th className="text-center">Aksi</th>
                            <th className="text-center">Nama File</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan="2">
                              <h6 className="text-info">Belum ada Dokumen</h6>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-4 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Skor
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                    <div className="py-5">
                      <table className="table table-row-dashed table-row-gray-300 gy-7">
                        <thead className="bg-primary text-white">
                          <tr className="fw-bolder fs-6">
                            <th className="text-center">Aksi</th>
                            <th className="text-center">Skor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan="2">
                              <h6 className="text-info">Belum ada Skor</h6>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*end::Accordion*/}
          </div>
        </>
      )}
    </>
  );
};

export default ScoreLipaComp;
